import { Student } from "../../../mp-database"
import { getSchoolYear } from "../../../mp-utils/generic-utils"

export default function computeStudentGrade(
  student: Student
): number | "graduated" | undefined {
  const { grade, graduationYear, lastName } = student
  const yearRegex = /(\d{4}|\d{4}\-\d{4})$/g
  const years = lastName?.match?.(yearRegex)

  let computedGrade: number | undefined

  const currentSchoolYear = getSchoolYear().year + 13

  if (graduationYear && graduationYear?.toString().length === 4) {
    let graduationYearNum = graduationYear

    if (typeof graduationYearNum === "string") {
      graduationYearNum = +graduationYearNum
    }

    if (graduationYearNum) {
      computedGrade = currentSchoolYear - graduationYearNum
    }

    if (grade && computedGrade && computedGrade < 0) {
      computedGrade = +grade
    }
  } else if (grade) {
    computedGrade = +grade
  } else if (lastName && years?.length) {
    const year = years[0]
    computedGrade = currentSchoolYear - Number(year)
  }

  if (computedGrade && computedGrade > 12) {
    return "graduated"
  }

  return computedGrade
}
